module.exports = __webpack_public_path__ + "static/media/tick_upi_icon.a5c7b88e.svg";